import { MatDividerModule } from '@angular/material/divider';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { HiddenTypeComponent } from './hidden-type.component';

@NgModule({
  declarations: [HiddenTypeComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'hidden',
          component: HiddenTypeComponent,
        },
      ],
    }),
  ],
})
export class HiddenTypeModule {}
